import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import {
  useMessage,
  useApproveMessage,
  useUnapproveMessage,
  useStartRevokingMessage,
  useDeleteMessage,
  useIsMessageMutating,
} from '#/components/ui/messages/endpoints';
import {
  IconArrowLeft,
  IconCheck,
  IconPencil,
  IconTrash,
  IconX,
} from '@tabler/icons-react';
import { MessageTemplateInfo } from '#/components/ui/messages/MessageTemplateInfo';
import {
  Flex,
  Paper,
  Stack,
  Text,
  Title,
  ActionIcon,
  Anchor,
  Group,
  Button,
} from '@mantine/core';
import {
  MessageLoading,
  MessageNotFound,
} from '#/components/ui/messages/components/ui';
import { MessageStateBadge } from '#/components/ui/messages';
import {
  useMessageCreatePresetStorage,
  useWithPresetParam,
} from '#/components/ui/messages/hooks/useMessagePreset';
import { toMessageFormValue } from '#/components/ui/messages/model';

const MessageInfoPage = () => {
  const navigate = useNavigate();
  const { setPreset } = useMessageCreatePresetStorage();
  const { applyParams } = useWithPresetParam();

  const params = useParams();
  const { data: messageTemplate, error, isLoading } = useMessage(params.id);
  const { mutate: approveMessage } = useApproveMessage(params.id);
  const { mutate: unapproveMessage } = useUnapproveMessage(params.id);
  const { mutate: startRevokingMessage } = useStartRevokingMessage(params.id);
  const { mutate: deleteMessage } = useDeleteMessage(params.id);
  const isMessageMutating = useIsMessageMutating(params.id);

  if (isLoading) {
    return <MessageLoading />;
  }

  if (error || !messageTemplate) {
    return <MessageNotFound />;
  }

  const { state } = messageTemplate;

  return (
    <Stack>
      <Anchor
        component={Link}
        to="/messages"
        w="fit-content"
        c="dimmed"
        fw={500}
      >
        <Group gap={6}>
          <ActionIcon variant="transparent" color="gray" size="sm">
            <IconArrowLeft size={16} />
          </ActionIcon>
          <Text size="sm">返回訊息管理頁</Text>
        </Group>
      </Anchor>
      <Paper radius="md" p="xl" pb="lg" withBorder className="flex-1">
        <Stack gap="lg" className="h-full">
          <Flex align={'center'} gap={10}>
            <Title order={2}>檢視訊息</Title>
            <MessageStateBadge state={messageTemplate.state} />
            <Flex className="ml-auto" gap={10}>
              {state === 'draft' && (
                <Button
                  color="blue"
                  variant="light"
                  leftSection={<IconPencil />}
                  onClick={() => {
                    navigate(`/messages/${messageTemplate.id}/edit`);
                  }}
                >
                  編輯
                </Button>
              )}
            </Flex>
          </Flex>
          <MessageTemplateInfo value={messageTemplate} />
          <Flex justify={'end'} gap="md">
            <Button
              color="blue"
              variant="outline"
              disabled={isMessageMutating}
              onClick={() => {
                const formValue = toMessageFormValue(messageTemplate);

                console.log({ messageTemplate, formValue });

                setPreset(formValue);

                const next = applyParams(`/messages/new`).toString();
                navigate(next);
              }}
            >
              複製訊息
            </Button>
            {state === 'draft' && (
              <Button
                color="red"
                variant="filled"
                disabled={isMessageMutating}
                leftSection={<IconTrash />}
                onClick={() => {
                  deleteMessage(undefined, {
                    onSuccess() {
                      navigate(`/messages/${messageTemplate.id}/`);
                    },
                  });
                }}
              >
                刪除訊息
              </Button>
            )}

            {state === 'published' && (
              <Button
                color="red"
                variant="filled"
                disabled={isMessageMutating}
                leftSection={<IconX />}
                onClick={() => {
                  startRevokingMessage(undefined);
                }}
              >
                撤回訊息
              </Button>
            )}
            {state === 'approved' && (
              <Button
                color="red"
                variant="filled"
                disabled={isMessageMutating}
                leftSection={<IconX />}
                onClick={() => {
                  // TODO
                  unapproveMessage(undefined, {
                    onSuccess() {
                      navigate(`/messages/${messageTemplate.id}/`);
                    },
                  });
                }}
              >
                取消審核
              </Button>
            )}
            {state === 'draft' && (
              <Button
                color="blue"
                variant="filled"
                disabled={isMessageMutating}
                leftSection={<IconCheck />}
                onClick={() => {
                  approveMessage(undefined, {
                    onSuccess() {
                      navigate(`/messages/${messageTemplate.id}/`);
                    },
                  });
                }}
              >
                完成審核
              </Button>
            )}
          </Flex>
        </Stack>
      </Paper>
    </Stack>
  );
};

export default MessageInfoPage;
